import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";
// import store from "@/store";

const state = {
  cities: [],
  pagination: {},
  addStatus: false,
};
const getters = {
  citiesListGet: (state) => state.cities,
  //citiesGetter: (state) => state.cities,
};
const actions = {
  // getCities1({ commit }, payload) {
  //   service.getFun(`cities?country_id=${payload?.id}`).then(
  //     (obj) => {
  //       var result = obj.data;
  //       console.log("cities", result);
  //       commit("citiesListSet", result);
  //     },
  //     (error) => {
  //       console.log("cities..." + error);
  //       toastError(error);
  //     }
  //   );
  // },
  getCities({ commit }, payload) {
    //payload is country.id
    console.log("ppp", payload);
    service.getFun(`cities?country_id=${payload.country_id}`).then(
      (obj) => {
        var result = obj.data;
        console.log("cities", result);
        commit("citiesListSet", result);
      },
      (error) => {
        console.log("cities..." + error);
        toastError(error);
      }
    );
  },

  async createCity({ commit }, payload) {
    const res = await service.postFun(payload, "cities", null, {
      action: "getCities",
      country: payload?.country_id,
    });
    if (res?.data) {
      commit("setAddCity", res?.success);
      commit("setCityErrors", []);
      toast("success");
    } else {
      commit("setCityErrors", res);
    }
  },
  editCity({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `cities/${payload.id}`,
        null,
        {
          action: "getCities",
          COUNTRY: payload?.country_id,
        }
      )
      .then((result) => {
        commit("editCity", result.success);
        toast(result.message);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  deleteCity({ commit }, payload) {
    console.log("pdelete", payload);
    service
      .deleteFun(`cities/${payload.payload}`, {
        action: "getCities",
        COUNTRY: payload.country_id,
      })
      .then(
        (result) => {
          commit("deleteCityStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  // addCourse({ commit }, payload) {
  //   service.postFun(payload, `cities/store`).then(
  //     (result) => {
  //       commit("addcitiestatus", result.success);
  //     },
  //     (error) => {
  //       toastError(error);
  //     }
  //   );
  // },
};
const mutations = {
  citiesListSet(state, cities) {
    state.cities = cities;
  },
  addcitiestatus(state, Status) {
    state.addStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
  setAddCity(state, status) {
    state.addStatus = status;
  },
  setCityErrors(state, errors) {
    state.errors = errors;
  },
  deleteCityStatus(state, Status) {
    state.deleteStatus = Status;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
